import i18n, { InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { MRT_Localization_DE } from 'material-react-table/locales/de';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import { MRT_Localization } from "material-react-table";
import { initCountries } from "./countries";

export enum Locale {
  en = "en",
  de = 'de',
  fr = 'fr',
  it = 'it',
  es = 'es',
  nl = 'nl',
  zh = 'zh',
}

export const GUI_LOCALES = [ Locale.en, Locale.de, Locale.fr ];

const options: InitOptions = {
  fallbackLng: Locale.en,
  debug: true,
  supportedLngs: GUI_LOCALES,

  detection: {
    order: [ "querystring", "cookie", "localStorage", "navigator" ],
    caches: [ "localStorage", "cookie" ],
    excludeCacheFor: [ "cimode" ], // languages to not persist (cookie, localStorage)
  },
  returnObjects: true,
  react: {}
}

export function initI18n() {
  i18n
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init(options, undefined)
    .catch(console.error);

  initCountries();
}

export function getMaterialTableTranslation(): MRT_Localization {
  if (i18n.language === Locale.de) {
    return MRT_Localization_DE;
  } else {
    return MRT_Localization_EN
  }
}
